import React, { useState, useEffect, useRef } from 'react';
import { Icon, Tooltip, Loading } from '@b-design/fusion';
import Button from '@/components/Button';
import $i18n from '../../../../../i18n';
import CreateInfoDrawer from '@/components/CreateMiniappDrawer';
import CalculateComponent from '@/components/CalculateComponent';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';
import { formatTime } from '@/utils';

import './index.less';
import DefaultAppIcon from '@/components/DefaultAppIcon';

const infoListTitle = [
  {
    key: 'name',
    icon: <Icon type="mobile--outline" size="small" />,
    title: $i18n.get({ id: 'aopf.pages.miniapp.detail.info.Miniapp.Name', dm: '应用名称' }),
  },
  {
    key: 'appId',
    icon: <Icon type="gongwenbao_xianxing" size="small" />,

    title: $i18n.get({ id: 'aopf.pages.miniapp.detail.info.Miniapp.ID', dm: '应用ID' }),
  },
  {
    key: 'framework',
    icon: <Icon type="apps--outline" size="small" />,

    title: $i18n.get({ id: 'aopf.pages.miniapp.detail.info.Type', dm: '类型' }),
  },
  {
    key: 'createName',
    icon: <Icon type="user--outline" size="small" />,

    title: $i18n.get({ id: 'aopf.pages.miniapp.detail.info.Creator', dm: '创建者' }),
  },
  {
    key: 'gmtCreate',
    icon: <Icon type="calendar--outline" size="small" />,

    title: $i18n.get({ id: 'aopf.pages.miniapp.detail.info.Created.Time', dm: '创建时间' }),
  },
  {
    key: 'icon',
    icon: <Icon type="VIP--outline" size="small" />,

    title: $i18n.get({ id: 'aopf.pages.miniapp.detail.info.LOGO', dm: '标志' }),
  },
  {
    key: 'slogan',
    icon: <Icon type="wikis--outline" size="small" />,

    title: $i18n.get({ id: 'aopf.pages.miniapp.detail.info.Slogan', dm: '口号' }),
  },
  {
    key: 'description',
    icon: <Icon type="document--outline" size="small" />,

    title: $i18n.get({ id: 'aopf.pages.miniapp.detail.info.Description', dm: '描述' }),
  },
  {
    key: 'customerPhone',
    icon: <Icon type="phone--outline" size="small" />,

    title: $i18n.get({ id: 'aopf.pages.miniapp.detail.info.Contact.Number', dm: '联系电话' }),
  },
  {
    key: 'customerEmail',
    icon: <Icon type="email--outline" size="small" />,

    title: $i18n.get({ id: 'aopf.pages.miniapp.detail.info.Contact.Email', dm: '邮箱' }),
  },
  {
    key: 'party',
    icon: <Icon type="details--outline" size="small" />,

    title: $i18n.get({ id: 'aopf.pages.miniapp.create.drawer.belongTo', dm: '小程序权限' }),
  },
];

interface Props {
  info: any;
  setCreateTitle: any;
  loading: boolean;
  setLoading: any;
  currentTabKey: string;
  appRole: string[];
}

const Information: React.FC<Props> = ({
  info,
  setCreateTitle,
  loading,
  setLoading,
  currentTabKey,
  appRole,
}) => {
  const [visible, setVisible] = useState(false);
  const [currentApp, setCurrentApp] = useState({ title: 'Default Info', key: 'default' });
  const [contentHeight, setContentHeight] = useState(296);
  const [title, setTitle] = useState('');
  const [infoListArr, setInfoListArr] = useState<any>([]);
  const [tabListTitle, setTabListTitle] = useState('');
  const [flag, setFlag] = useState(false);
  const [infoChannelData, setInfoChannelData] = useState<any>({});
  const [infoContent, setInfoContent] = useState<string>('');
  const [shadow, setShadow] = useState(false);
  const ref = useRef<any>(null);
  const refContainer = useRef<any>(null);

  const { appId } = getQueryStringArgs();

  const init = () => {
    setLoading(true);
    Requests.get('/rest/intercnn/app/publish/query', { appId, currentPage: 1, pageSize: 999 }).then(
      (data) => {
        if (data) {
          const { list = [] } = data;
          const infoList: any = [
            {
              title: $i18n.get({
                id: 'aopf.pages.miniapp.detail.Component.information.defaultInfo',
                dm: '默认信息',
              }),
              key: 'default',
            },
          ];
          list.forEach((item) => {
            if (!item.description.inherit) {
              infoList.push({ title: item.channelName, key: item.channelCode });
            }
          });
          infoList.push({ title: 'Add', key: 'add' });
          setInfoListArr(infoList);
          setLoading(false);
        }
      },
    );
  };

  useEffect(() => {
    const sonRef = ref?.current.offsetWidth;
    const parentRef = refContainer?.current.offsetWidth;
    if (sonRef >= parentRef) {
      setShadow(true);
    } else {
      setShadow(false);
    }
  }, [infoListArr]);

  useEffect(() => {
    if (currentTabKey === 'Information') {
      init();
    }
  }, [currentTabKey]);

  useEffect(() => {
    if (tabListTitle === 'addInfo') {
      init();
      setTabListTitle('');
    }
  }, [tabListTitle]);

  const renderImgIcon = (item) => {
    if (currentApp.key === 'default' && !flag) {
      return info[item.key] ? (
        <img src={info[item.key]} className="img-info-detail" alt="" />
      ) : (
        <DefaultAppIcon className="img-info-detail" />
      );
    } else {
      return infoChannelData[item.key] ? (
        <img src={infoChannelData[item.key]} className="img-info-detail" alt="" />
      ) : (
        <DefaultAppIcon className="img-info-detail" />
      );
    }
  };

  const renderContent = (item) => {
    if (item.key === 'icon') {
      return renderImgIcon(item);
    } else {
      if (currentApp.key === 'default' && !flag) {
        if (item.key === 'party') {
          return info?.party === 'THIRD'
            ? $i18n.get({
                id: 'aopf.pages.miniapp.create.drawer.tripartiteMiniApp',
                dm: '普通',
              })
            : info?.party === 'PRIVILEGE'
            ? $i18n.get({
                id: 'aopf.pages.miniapp.create.drawer.oneSideMiniapp',
                dm: '特权',
              })
            : '';
        } else if (item.key === 'customerPhone') {
          if (info[item.key] !== '-') {
            if (info[item.key]?.split('-')[0]) {
              return `+${info[item.key]?.split('-')[0]} ${info[item.key]?.split('-')[1]}`;
            } else {
              return `${info[item.key]?.split('-')[1]}`;
            }
          }
        } else {
          return info[item.key];
        }
      } else {
        if (item.key === 'party') {
          return infoChannelData?.party === 'THIRD'
            ? $i18n.get({
                id: 'aopf.pages.miniapp.create.drawer.tripartiteMiniApp',
                dm: '普通',
              })
            : infoChannelData?.party === 'PRIVILEGE'
            ? $i18n.get({
                id: 'aopf.pages.miniapp.create.drawer.oneSideMiniapp',
                dm: '特权',
              })
            : '';
        } else if (item.key === 'customerPhone') {
          if (infoChannelData[item.key] !== '-') {
            if (infoChannelData[item.key]?.split('-')[0]) {
              return `+${infoChannelData[item.key]?.split('-')[0]} ${
                infoChannelData[item.key]?.split('-')[1]
              }`;
            } else {
              return `${infoChannelData[item.key]?.split('-')[1]}`;
            }
          }
        } else {
          return infoChannelData[item.key];
        }
      }
    }
  };

  const renderInfo = () => {
    return (
      <div style={{ position: 'relative', marginLeft: 24, height: contentHeight }}>
        <Loading visible={loading}>
          {infoListTitle.map((item, index) => (
            <div
              className="container-info-detail"
              style={{ marginTop: index === 0 ? 24 : 0 }}
              key={index}
            >
              <div className="row-container">
                <div className="title-info-detail">
                  {item.icon}
                  <span className="title-info-detail-font">{item.title}</span>
                </div>
                <div className="content-info-detail">{renderContent(item)}</div>
              </div>
            </div>
          ))}
        </Loading>

        {appRole?.includes('ADMIN') ? (
          <Button
            type="primary"
            data-child-type="icon-text"
            style={{ position: 'absolute', top: '-78px', right: 32, width: 76, height: 32 }}
            onClick={() => {
              setVisible(true);
              currentApp.key === 'default' ? setTitle('edit') : setTitle('editInfo');
            }}
          >
            <Icon type="edit--filled" />
            {$i18n.get({ id: 'aopf.pages.miniapp.detail.info.Edit.btn', dm: '编辑' })}
          </Button>
        ) : null}
      </div>
    );
  };

  const changeTabs = (v) => {
    if (v.key !== 'add') {
      setCurrentApp(v);
    }
  };

  const changeTab = () => {
    setLoading(true);
    Requests.get('/rest/intercnn/app/publish/query', {
      appId,
      channelCode: currentApp.key,
    }).then((data) => {
      if (data) {
        const temp = data.list[0];
        const obj = {
          name: temp.description.name,
          appId: temp.appId,
          createName: temp.description.createName,
          gmtCreate: formatTime(temp.gmtCreate),
          framework: info.framework,
          customerPhone: temp.description.customerPhone,
          customerEmail: temp.description.customerEmail,
          icon: temp.description.iconPublicUrl,
          iconRelative: temp.description.icon,
          slogan: temp.description.slogan,
          description: temp.description.description,
          channelName: temp.channelName,
          party: temp.description.party,
        };
        setInfoChannelData(obj);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (currentApp.key !== 'default') {
      changeTab();
    } else {
      setFlag(false);
    }
  }, [currentApp]);

  useEffect(() => {
    if (infoContent === 'updateMiniappInfo') {
      changeTab();
      setInfoContent('');
    }
  }, [infoContent]);

  useEffect(() => {
    if (currentApp.key !== 'default') {
      setFlag(true);
    }
  }, [infoChannelData]);

  return (
    <div className="information-content">
      <div className="sub-tabs">
        <div className={`sub-tabs-div ${shadow ? 'sub-tabs-div-shadow' : ''}`} ref={refContainer}>
          <div ref={ref} style={{ display: 'inline-block' }}>
            {infoListArr.map((v) => (
              <span
                key={v.key}
                className={currentApp.key === v.key ? 'sub-tab-item-current' : 'sub-tab-item'}
                onClick={() => changeTabs(v)}
              >
                {appRole?.includes('ADMIN') ? (
                  <>
                    {v.key === 'add' ? (
                      <Tooltip
                        align="b"
                        v2
                        trigger={
                          <Icon
                            type="add--circle--filled"
                            style={{ color: 'var(--superapp-primary-1)' }}
                            onClick={() => {
                              setVisible(true);
                              setTitle('addInfo');
                            }}
                          />
                        }
                        closable={false}
                        style={{
                          width: 176,
                        }}
                      >
                        {$i18n.get({
                          id: 'aopf.pages.miniapp.detail.info.add.icon.tips',
                          dm: '如果您希望为每个渠道生成差异化的应用信息，可在此处添加',
                        })}
                      </Tooltip>
                    ) : (
                      v.title
                    )}
                  </>
                ) : (
                  <>{v.key !== 'add' ? v.title : null}</>
                )}
              </span>
            ))}
          </div>
        </div>
      </div>

      {renderInfo()}

      <CalculateComponent
        otherWidth={280}
        otherHeight={108 + 80 + 80}
        windowChange={(_width, height) => {
          setContentHeight(height);
        }}
      />
      <CreateInfoDrawer
        visible={visible}
        setVisible={setVisible}
        status={title}
        appInfo={currentApp.key === 'default' || title === 'addInfo' ? info : infoChannelData}
        setCreateTitle={setCreateTitle}
        setTabListTitle={setTabListTitle}
        channel={currentApp.key}
        setInfoContent={setInfoContent}
        appTypeInfo={info.framework}
      />
    </div>
  );
};

export default Information;
